var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOkIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6528_6593)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_6528_6593",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 48,
  height: 48
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M48 0H0V48H48V0Z",
  fill: "white"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_6528_6593)"
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.2837 17.7107L20.7049 30.2896L14.7168 24.3016",
  stroke: "#546BD6",
  strokeWidth: 1.4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask1_6528_6593",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 48,
  height: 48
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 1.14441e-05H48V48H0V1.14441e-05Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_6528_6593)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.125 24C46.125 36.2193 36.2193 46.125 24 46.125C11.7807 46.125 1.875 36.2193 1.875 24C1.875 11.7807 11.7807 1.87501 24 1.87501C36.2193 1.87501 46.125 11.7807 46.125 24Z",
  fill: "#546BD6",
  fillOpacity: 0.16,
  stroke: "#546BD6",
  strokeWidth: 1.4,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6528_6593"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "white"
})))));
export { SvgOkIcon as ReactComponent };
export default __webpack_public_path__ + "086d0a439b40e1f30b7730b8b1184c2b.svg";